<template>
	<div>
		<div class="slider">
			<div class="response">
				<div class="answer-wrapper">
					<div v-if="!isAnswered" class="no-answer">
						<span>
							Not Answered
						</span>
					</div>
					<LineGraph v-else-if="isScored" 
						class="line-graph" 
						name="Response"
						:max="getMaxScore"
						:data="getGraphData.reverse()">
					</LineGraph>
					<SliderPartial
						v-else
						class="line-graph"
						:isSurvey="false"
						:question="question"
						:data="getGraphData"
					></SliderPartial>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionResponse from '.'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from '@/module/component/LoadingButton.vue'
import SelectValue from './mixin/select-value'
import SliderPartial from './partialResponse/SliderPartial'
import LineGraph from './partialResponse/LineGraph.vue'

export default {
	extends: QuestionResponse,
	mixins: [ SelectValue ],

	data() {
		return {
		}
	},

	methods: {
		getScore(val) {
			let idx = null
			this.question.options.forEach((option, index) => {
				if (option.value === val) {
					idx = index
				}
			})
			return idx !== null ? this.question.score.default[idx] : 0
		}
	},

	computed: {
		getMaxScore() {
			let max = 0
			if (this.isScored) {
				Object.keys(this.question.score.default).forEach(k => {
					if (this.question.score.default[k] > max) max = this.question.score.default[k]
				})
			}
			return max
		},
		isAnswered() {
			let found = false
			this.oresponse.forEach(res => {
				if (res) found = true
			})
			return found
		},
		getGraphData() {
			let data = []
			this.oresponse.forEach((res, index) => {
				if (res && res.length) {
					if (this.isScored) {
						let score = 0
						res.forEach(r => score += this.getScore(r.value))
						data.push({ 'date': this.questionnaireDate(index), 'value': score })
					} else {
						let values = []
						res.forEach(optionRes => values.push(optionRes.value))
						data.push({ 'date': this.questionnaireDate(index), 'value': values })
					}
				}
			})
			return data
		}
	},
	
	components: {
		LineGraph,
		SliderPartial,
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
